VP = window.VP || {};

/*
 * lazy load tiktok
*/

(function ($) {
  VP.ttlazy = {


    init: function () {
      var _this = this;
      if ($(".lazy-tiktok:not('.loaded')").length) {
        // console.log("[ttlazy] init (queued)");
        _this.eventHandlers();
      }
      else {
        // console.log("no [ttlazy]");
      }
    },
    loadTT: function ($elem, loadnext) {

      var _this = this;
      var _url = $elem.data("url");
      //var _isvideo = ($elem.data("isvideo") == "1");
      _url = _url.split('?')[0]; // remove any query string

      var triggernext = loadnext == true;

      // console.log("[ttlazy] loading tiktok... " + _url);
      // Fire off the request to ajax.php
      $elem.addClass("loaded");
      VP.request.get(
        'tt',
        {
          url: _url,
        },
        function (response) {
          if (response && response != "") {
            json = JSON.parse(response);
            //console.log(json.html);
            if (json.html) {

              $elem.html("<div class='tiktok-wrap hidelikes'><div class='tiktok-container'>" + json.html + "</div><div class='tiktok-base'></div></div>");
            // console.log(json.html);
            //window.instgrm.Embeds.process(); // TODO:: REUP TIK TOK REFRESH???
              

              VP.quicklinks.updateMetrics();
              VP.ttlazy.checkBaseSize();
            }
          }
          else {
            console.error("parse error, Unable to load tiktok, it's probably no longer there: " + _url);
          }
        },
        function (error, xhr) {
          console.error("general error, Unable to load tiktok: " + _url);
        },
        function (response) { // always
          if (triggernext) {
            // console.log("trigger next");
            VP.ttlazy.loadFirstItem();
          }
        }
      );

    },
    checkBaseSize: function () {
      return;

      //  console.log("[ttlazy] check base size");
      $igs = $(".instagram-wrap.hidelikes");
      if (!$igs.length) return;
      $igs.each(function () {
        $iframe = $igs.find(".instagram-media");
        $ibase = $igs.find(".instagram-base");
        if ($ibase.length && $iframe.length) {
          $ibase.width($iframe.width());
        }
      });

      $(".instagram-media").each(function () {
        // console.log($(this).width());
        $(this).parents(".instagram-wrap").find(".instagram-base").width($(this).width());
        // console.log($(this).parents(".instagram-wrap").find(".instagram-base").length);
      });
    },
    checkScrollPosition: function () {
      var _this = this;
      $toload = $(".lazy-tiktok:not('.loaded')");
      if (!$toload.length) {
        return;
      }
      buffer = $(window).height() * 1.4;  // buffer is a multiple of page height
      windowTop = $(window).scrollTop();
      windowBottom = windowTop + $(window).height() + buffer;

      $toload.each(function () {
        if ($(this).offset().top < windowBottom) {
          _this.loadTT($(this));
        }
      });

    },

    loadFirstItem: function () {
      var _this = this;
      $toload = $(".lazy-tiktok:not('.loaded')").first();
      if (!$toload.length) {
        return;
      }

      VP.ttlazy.loadTT($toload, true);

    },
    eventHandlers: function () {
      var _this = this;

      VP.documentEvents.onDelayInit(VP.ttlazy.loadFirstItem);
      VP.documentEvents.onResize(_this.checkBaseSize.bind(_this), true);

    }
  };
})(jQuery);
